import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=29a2c5c9&scoped=true&"
import script from "./PartnerView.vue?vue&type=script&lang=js&"
export * from "./PartnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2c5c9",
  null
  
)

export default component.exports